import { render, staticRenderFns } from "./modalAddMedia.vue?vue&type=template&id=0655cb16&"
import script from "./modalAddMedia.vue?vue&type=script&lang=js&"
export * from "./modalAddMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports